/* L'état du réseau, tel que l'écran doit le dire.
 *
 * Une simple passerelle React au-dessus de `file.ts` : celle-ci vit hors de
 * React, parce qu'une écriture doit pouvoir être rangée depuis n'importe où —
 * y compris depuis un gestionnaire qui n'a pas de composant sous la main.
 *
 * On ne se fie pas à `navigator.onLine` seul. Il dit « en ligne » dès qu'une
 * interface réseau existe : le wifi du club-house auquel on est associé sans
 * qu'il route quoi que ce soit passe pour une connexion. La vérité est ce que
 * répondent les vraies requêtes, et c'est ce que la file mesure.
 */

import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import type { EtatFile } from './file.ts';
import { abonner, demarrerFile, etatFile, oublierPertes, vidanger } from './file.ts';

interface Reseau extends EtatFile {
    /** Force une tentative — le bouton « réessayer » de l'indicateur. */
    reessayer: () => void;
    oublierPertes: () => void;
}

const Ctx = createContext<Reseau | null>(null);

export function ReseauProvider({ children }: { children: ReactNode }) {
    const [etat, setEtat] = useState<EtatFile>(etatFile);

    useEffect(() => {
        demarrerFile();
        return abonner(setEtat);
    }, []);

    return (
        <Ctx.Provider value={{ ...etat, reessayer: () => void vidanger(), oublierPertes }}>
            {children}
        </Ctx.Provider>
    );
}

export function useReseau(): Reseau {
    const c = useContext(Ctx);
    if (!c) throw new Error('useReseau hors de ReseauProvider');
    return c;
}
